export const formatDateTime = (dateString: string | Date, showTime = true): string => {
  const date = new Date(dateString);
  const options: Intl.DateTimeFormatOptions = showTime
    ? { year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', hour12: true }
    : { year: 'numeric', month: 'short', day: 'numeric' };
  return date.toLocaleString('en-US', options);
};
